import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './BigBlueBox.module.scss';

export default class BigBlueBox extends Component {
  static defaultProps = {
    joinOurTeam: '',
    traffitFormLink: '',
    apply: '',
    openInNewTab: true,
  };

  static propTypes = {
    joinOurTeam: PropTypes.string.isRequired,
    traffitFormLink: PropTypes.string.isRequired,
    apply: PropTypes.string.isRequired,
    openInNewTab: PropTypes.bool,
  };

  render() {
    const { joinOurTeam, traffitFormLink, apply, openInNewTab } = this.props;

    return (
      <div className={styles.Container}>
        <div className={styles.DivJoinOurTeam}>
          <p className={styles.WhiteText}>{joinOurTeam}</p>
        </div>
        <a 
          href={traffitFormLink} 
          target={openInNewTab ? "_blank" : "_self"} 
          rel="noreferrer" 
          className={styles.DivTraffitLink}
        >
          <p className={styles.SpanTraffitLink}>{apply}</p>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/components/BigBlueBox/BigBlueBox.js